const e = "Rensa sökfält", l = "Välj alternativ", a = {
  clearSearch: e,
  selectPlaceholder: l,
  "Select.InputSearch.Value:placeholder": "Sök",
  "Select.InputSearch.Value:aria-label": "Sök"
};
export {
  e as clearSearch,
  a as default,
  l as selectPlaceholder
};
